import React from 'react';
import { WHAT_I_DO, WHAT_I_DO_HEADER } from '../mock';

export default function WhatIDo() {
  return (
    <section id="what-i-do" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 md:gap-12 mb-14 md:mb-20">
          <div className="md:col-span-5">
            <div className="mono text-[11px] uppercase tracking-[0.2em] mb-4" style={{ color: 'var(--terracotta)' }}>
              {WHAT_I_DO_HEADER.kicker}
            </div>
            <h2
              className="display"
              style={{
                fontSize: 'clamp(2rem, 4.5vw, 3.6rem)',
                lineHeight: 1.05,
                fontWeight: 400,
                color: 'var(--ink)',
              }}
            >
              Three roles, but it is really{' '}
              <em className="italic serif" style={{ color: 'var(--forest)' }}>one habit.</em>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-[15px] md:text-[17px] leading-relaxed" style={{ color: 'var(--forest-soft)' }}>
              {WHAT_I_DO_HEADER.description}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px" style={{ background: 'rgba(15,27,20,0.1)' }}>
          {WHAT_I_DO.map((r, i) => (
            <div
              key={r.role}
              className="p-8 md:p-10 group"
              style={{ background: 'var(--bone)' }}
            >
              <div className="flex items-baseline justify-between mb-6">
                <span className="mono text-[11px] uppercase tracking-[0.2em]" style={{ color: 'var(--stone)' }}>
                  0{i + 1}
                </span>
                <span className="mono text-[11px] uppercase tracking-[0.2em]" style={{ color: 'var(--moss)' }}>
                  {r.label}
                </span>
              </div>
              <h3
                className="display mb-4"
                style={{
                  fontSize: 'clamp(1.5rem, 2.4vw, 2rem)',
                  lineHeight: 1.1,
                  fontWeight: 500,
                  color: 'var(--ink)',
                }}
              >
                {r.role}
              </h3>
              <p className="text-[15px] leading-relaxed mb-6" style={{ color: 'var(--forest-soft)' }}>
                {r.blurb}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {r.tools.map((t) => (
                  <span
                    key={t}
                    className="mono text-[10px] uppercase tracking-[0.14em] px-2 py-1 rounded"
                    style={{
                      background: 'var(--bone-deep)',
                      color: 'var(--forest)',
                    }}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
